<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      model: [],
      dataSource: [
        {
          value: 'all',
          label: 'Todos',
          expanded: true,
          items: this.items
        }
      ]
    }
  },
  created () {
    this.model = this.value
  },
  watch: {
    value () {
      this.model = this.value
    },
    items () {
      this.dataSource = [
        {
          value: 'all',
          label: 'Todos',
          expanded: true,
          items: this.items
        }
      ]
    }
  },
  methods: {
    syncTreeView (e) {
      let treeView = (e.component.selectItem && e.component) || (this.$refs.treeView && this.$refs.treeView.instance)
      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll()
        } else {
          let values = e.value || this.model
          if (this.items.length === values.length) treeView.selectItem('all')
          values && values.forEach(function (value) {
            treeView.selectItem(value)
          })
        }
      }
    },
    itemSelection (e) {
      let checkItem = (e) => {
        let i = this.model.indexOf(e.value)
        if (i === -1) this.model.push(e.value)
      }

      let treeView = (e.component.selectItem && e.component) || (this.$refs.treeView && this.$refs.treeView.instance)
      let item = e.node.itemData
      if (item.value !== 'all') {
        if (item.selected) checkItem(item)
        else {
          let i = this.model.indexOf(item.value)
          if (i !== -1) this.model.splice(i, 1)
        }
      } else {
        if (!item.selected) {
          this.model = []
          treeView.unselectAll()
        } else {
          this.model = []
          this.items.forEach(e => checkItem(e))
        }
      }
      this.$emit('change', this.model)
    }
  }
}
</script>

<template>
  <dx-drop-down-box :value.sync="model" :data-source="items" value-expr="value" display-expr="label" placeholder="Selecione o índice..." @value-changed="syncTreeView($event)">
    <div slot="content" slot-scope="data">
      <dx-tree-view
        ref="treeView"
        :data-source="dataSource"
        :select-by-click="true"
        :select-nodes-recursive="false"
        key-expr="value"
        selection-mode="multiple"
        show-check-boxes-mode="normal"
        display-expr="label"
        @content-ready="syncTreeView($event)"
        @item-selection-changed="itemSelection($event)" />
    </div>
  </dx-drop-down-box>
</template>
